window.addEventListener("scroll", (event) => {
  header.toggleAttribute("data-pinned", scrollY > 100);
});
